import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.e5i().t5k(), $completion));
  return SavedHttpCall().c5m(_this__u8e3s4.z5h_1, _this__u8e3s4.e5k(), _this__u8e3s4.e5i(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static c5m(client, request, response, responseBody) {
        var $this = this.d5k(client);
        $this.a5m_1 = responseBody;
        $this.b5i_1 = new (SavedHttpRequest())($this, request);
        $this.c5i_1 = new (SavedHttpResponse())($this, $this.a5m_1, response);
        checkContentLength(contentLength(response), fromInt($this.a5m_1.length), request.m5k());
        $this.b5m_1 = true;
        return $this;
      }
      g5k() {
        return this.b5m_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.d5m_1 = origin;
        this.e5m_1 = call;
      }
      l5k() {
        return this.e5m_1;
      }
      dw() {
        return this.d5m_1.dw();
      }
      m5k() {
        return this.d5m_1.m5k();
      }
      n5k() {
        return this.d5m_1.n5k();
      }
      f5k() {
        return this.d5m_1.f5k();
      }
      r2o() {
        return this.d5m_1.r2o();
      }
      y51() {
        return this.d5m_1.y51();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.f5m_1 = call;
        this.g5m_1 = body;
        this.h5m_1 = origin.u5k();
        this.i5m_1 = origin.v5k();
        this.j5m_1 = origin.w5k();
        this.k5m_1 = origin.x5k();
        this.l5m_1 = origin.y51();
        this.m5m_1 = origin.dw();
      }
      l5k() {
        return this.f5m_1;
      }
      u5k() {
        return this.h5m_1;
      }
      v5k() {
        return this.i5m_1;
      }
      w5k() {
        return this.j5m_1;
      }
      x5k() {
        return this.k5m_1;
      }
      y51() {
        return this.l5m_1;
      }
      dw() {
        return this.m5m_1;
      }
      t5k() {
        return ByteReadChannel(this.g5m_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
